import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonOrdersService } from '../../commonOrders.service';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-order-details-new',
  templateUrl: './order-details-new.component.html',
  styleUrls: ['./order-details-new.component.scss']
})
export class OrderDetailsNewComponent implements OnInit {

  isLoader: boolean = false;

  currentOrderId: number;
  currentOrderDetails = null;

  constructor(public route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonOrdersService: CommonOrdersService) { }

  ngOnInit() {
    this.isLoader = true;
    // get current order from params
    this.route.params.subscribe(params => {
      this.currentOrderId = params && params.id ? params.id : this.data.id;
      this.orderInfo();
    }, () => {
      this.isLoader = false;
    });
  }

  orderInfo() {
    this.commonOrdersService.getOrderByOrderIdNew(this.currentOrderId).then((response: any) => {
      let tempOrderArray = response && response.data && response.data.allOrders && response.data.allOrders.nodes.length > 0 ? response.data.allOrders.nodes : null;
      if (tempOrderArray) {
        this.commonOrdersService.checkDocProcess(tempOrderArray).then((ordersRes: any) => {
          if (ordersRes && ordersRes.length > 0) {
            this.currentOrderDetails = ordersRes[0];
            this.isLoader = false;
          }
          else {
            this.currentOrderDetails = tempOrderArray && tempOrderArray.length > 0 ? tempOrderArray[0] : null;
            this.isLoader = false;
          }
        });
      }
      else {
        this.isLoader = false;
      }
    }).catch((err) => {
      this.isLoader = false;
    });
  }

  onReportChange(event) {
    this.currentOrderDetails = null;
    this.orderInfo();
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-details-new/order-details-new.component.ts